// External libraries
import styled from '@emotion/styled';

// Internal modules
import { ERROR_COLOR, getWordBreak, HEADER_COLOR } from '@/styles';

const ErrorContainer = styled.div`
  background-color: #fff7f7;
  border: 1px solid ${ERROR_COLOR};
  border-radius: 4px;
  display: flex;
  margin-bottom: 15px;
  padding: 10px;
`;

const ErrorMessage = styled.p`
  color: ${HEADER_COLOR};
  font-size: 15px;
  line-height: 1.35;
  margin-left: 9px;

  ${'' /* 27px ==> 9px margin-left + 18px width of <ErrorIcon /> */}
  ${getWordBreak('27px')}
`;

export { ErrorContainer, ErrorMessage };
